import { useState } from "react"
import { FaChevronLeft, FaChevronRight } from "react-icons/fa"
import Popup from "../../component/Popup"
import TrendImages from "./TrendImages"
import { useSelector } from "react-redux";
import SocialLeaderboardTrend from "./SocialLeaderboardTrend";
import RetailerLeaderboardTrend from "./RetailerLeaderboardTrend";
import DemandPieCharts from "./DemandPieCharts";
import DemandForecastTable from "./DemandForecastTable";

const GroupTrend = ({ searchParams, trendsData, index, setSearchParams, sort, showPieCharts, demandForecastType, salesTarget, isDemandForecast, old45daysTrendsGroup, isMyntra = false }) => {
  const userLoggedIn = useSelector(state => state.userLoggedIn)

  const [page, setPage] = useState(1)
  const [selectedTagValue, setSelectedTagValue] = useState(null)
  return <div className={`w-full lg:w-1/2 lg:odd:border-r lg:odd:border-r-black border-b border-b-black p-2 shrink-0 ${index % 4 == 2 || index % 4 == 1 ? 'bg:bg-slate-100 bg-white' : 'bg-white'}`} id={trendsData.tag}>
    <h3 className="text-center font-bold my-2 text-[20px] mb-4">{trendsData.tag}</h3>
    {isDemandForecast ? <DemandForecastTable trends={trendsData.socialTrends} demandForecastType={demandForecastType} salesTarget={salesTarget} setShowImagesPopup={setSelectedTagValue} NATrends={trendsData.NATrends} olderTrends={old45daysTrendsGroup.socialTrends ? old45daysTrendsGroup.socialTrends : []} olderNATrends={old45daysTrendsGroup.NATrends ? old45daysTrendsGroup.NATrends : []} />
      : showPieCharts ? <DemandPieCharts trends={trendsData.socialTrends} demandForecastType={demandForecastType} salesTarget={salesTarget} setShowImagesPopup={setSelectedTagValue} NATrends={trendsData.NATrends} /> : !isMyntra ? <>
        <div className="w-full flex ">
          <div className={`w-1/2 shrink-0  border-dashed border-black border-r-[0.8px]`}>
            <div className='m-2 justify-center flex'>{sort != 'social' && sort != 'retailer' ? <img src={'/social-logo.png'} className='h-5' /> : <p className="font-semibold">DOMINANT TRENDS </p>}</div>
            <div className="flex justify-end">
              <hr className="w-3/4 border-dashed border-black border-[0.95px]" />
            </div>
            <div>
              {
                trendsData.socialTrends
                  ? trendsData.socialTrends.slice((page - 1) * 5, page * 5).map((trend, i) => sort != 'retailer' ? <SocialLeaderboardTrend
                    trendsData={trendsData}
                    trend={trend}
                    userLoggedIn={userLoggedIn}
                    searchParams={searchParams}
                    setSearchParams={setSearchParams}
                    setSelectedTagValue={setSelectedTagValue}
                    page={page}
                    index={i}
                    bgColor={index % 4 == 2 || index % 4 == 1 ? 'bg-white lg:bg-slate-100' : 'bg-white'}
                  /> : <RetailerLeaderboardTrend
                    trendsData={trendsData}
                    trend={trend}
                    userLoggedIn={userLoggedIn}
                    searchParams={searchParams}
                    setSearchParams={setSearchParams}
                    setSelectedTagValue={setSelectedTagValue}
                    page={page}
                    index={i}
                    bgColor={index % 4 == 2 || index % 4 == 1 ? 'bg-white lg:bg-slate-100' : 'bg-white'}
                  />) : null
              }

              {
                trendsData.socialTrends && trendsData.socialTrends.length < page * 5 ? Array.from({ length: (page * 5 - trendsData.socialTrends.length) % 5 }, (v, i, k,) => i)
                  .map((trend, index) => <div key={`${index}`} className="flex h-24 my-1">
                    <div className="shrink-0 w-40">
                    </div>
                    <div className="h-full px-1">
                      <div className="flex h-full overflow-x-hidden ">
                      </div>
                    </div>
                  </div>)
                  : null
              }
            </div>
          </div>
          <div className="w-1/2  border-dashed border-black border-l-[0.8px] shrink-0" >
            <div className='m-2 justify-center flex'>{sort != 'social' && sort != 'retailer' ? <img src={'/retailer-logo.png'} className='h-5' /> : <p className="font-semibold">RISING TRENDS</p>}</div>
            <div className="flex justify-start">
              <hr className="w-3/4 border-dashed border-black border-[0.95px]" />
            </div>
            <div>
              {
                trendsData.retailerTrends ? trendsData.retailerTrends.slice((page - 1) * 5, page * 5).map((trend, i) => sort != 'social' ? <RetailerLeaderboardTrend
                  trendsData={trendsData}
                  trend={trend}
                  userLoggedIn={userLoggedIn}
                  searchParams={searchParams}
                  setSearchParams={setSearchParams}
                  setSelectedTagValue={setSelectedTagValue}
                  page={page}
                  index={i}
                  bgColor={index % 4 == 2 || index % 4 == 1 ? 'bg-white lg:bg-slate-100' : 'bg-white'}
                /> : <SocialLeaderboardTrend
                  trendsData={trendsData}
                  trend={trend}
                  userLoggedIn={userLoggedIn}
                  searchParams={searchParams}
                  setSearchParams={setSearchParams}
                  setSelectedTagValue={setSelectedTagValue}
                  page={page}
                  index={i}
                  bgColor={index % 4 == 2 || index % 4 == 1 ? 'bg-white lg:bg-slate-100' : 'bg-white'}
                />) : null
              }

              {
                trendsData.retailerTrends && trendsData.retailerTrends.length < page * 5 ? Array.from({ length: (page * 5 - trendsData.retailerTrends.length) % 5 }, (v, i, k,) => i)
                  .map((trend, index) => <div key={`${index}`} className="flex h-24 my-1">
                    <div className="shrink-0 w-28">
                    </div>
                    <div className="h-full px-1">
                      <div className="flex h-full overflow-x-hidden ">
                      </div>
                    </div>
                  </div>)
                  : null
              }
            </div>
          </div>
        </div>
        <div className="flex justify-end my-2">
          <div className="flex px-4 ">
            <button onClick={() => setPage(prev => prev - 1)} disabled={page == 1}><FaChevronLeft size={25} color={page == 1 ? 'gray' : 'black'} /></button>
            <button onClick={() => setPage(prev => prev + 1)} disabled={page * 5 >= Math.max(trendsData.socialTrends.length, trendsData.retailerTrends.length)}><FaChevronRight size={25} color={page * 5 >= Math.max(trendsData.socialTrends.length, trendsData.retailerTrends.length) ? 'gray' : 'black'} /></button>
          </div>
        </div>
      </> : <>

        <div className='m-2 justify-center flex'> <img src={isMyntra && searchParams.get('category') == 'Ethinic Wear' ? '/myntra-logo.png' : '/retailer-logo.png'} className='h-5' /> </div>
        <div className="w-full flex ">

          <div className={`w-1/2 shrink-0  border-dashed border-black border-r-[0.8px]`}>
            <div className="flex justify-end">
              <hr className="w-3/4 border-dashed border-black border-[0.95px]" />
            </div>
            <div>
              {

                trendsData.retailerTrends.slice((page - 1) * 10, (page * 10) - 5).map((trend, i) => <RetailerLeaderboardTrend
                  trendsData={trendsData}
                  trend={trend}
                  userLoggedIn={userLoggedIn}
                  searchParams={searchParams}
                  setSearchParams={setSearchParams}
                  setSelectedTagValue={setSelectedTagValue}
                  page={page}
                  index={i}
                  isMyntra={true}
                  indexOffset={(page - 1) * 10}
                  bgColor={index % 4 == 2 || index % 4 == 1 ? 'bg-white lg:bg-slate-100' : 'bg-white'}
                />)
              }

              {
                trendsData.retailerTrends.length < (page * 10) - 5 ? Array.from({ length: (page * 10 - trendsData.retailerTrends.length - 5) % 5 }, (v, i, k,) => i)
                  .map((trend, index) => <div key={`${index}`} className="flex h-24 my-1">
                    <div className="shrink-0 w-40">
                    </div>
                    <div className="h-full px-1">
                      <div className="flex h-full overflow-x-hidden ">
                      </div>
                    </div>
                  </div>)
                  : null
              }
            </div>
          </div>
          <div className={`w-1/2 shrink-0  border-dashed border-black border-r-[0.8px]`}>
            <div className="flex justify-end">
              <hr className="w-3/4 border-dashed border-black border-[0.95px]" />
            </div>
            <div>
              {

                trendsData.retailerTrends.slice((page - 1) * 10 + 5, (page * 10)).map((trend, i) => <RetailerLeaderboardTrend
                  trendsData={trendsData}
                  trend={trend}
                  userLoggedIn={userLoggedIn}
                  searchParams={searchParams}
                  setSearchParams={setSearchParams}
                  setSelectedTagValue={setSelectedTagValue}
                  page={page}
                  index={i}
                  isMyntra={true}
                  indexOffset={(page - 1) * 10 + 5}
                  bgColor={index % 4 == 2 || index % 4 == 1 ? 'bg-white lg:bg-slate-100' : 'bg-white'}
                />)
              }

              {
                trendsData.retailerTrends.length < (page * 10) - 5 ? Array.from({ length: (page * 10 - trendsData.retailerTrends.length - 5) % 5 }, (v, i, k,) => i)
                  .map((trend, index) => <div key={`${index}`} className="flex h-24 my-1">
                    <div className="shrink-0 w-40">
                    </div>
                    <div className="h-full px-1">
                      <div className="flex h-full overflow-x-hidden ">
                      </div>
                    </div>
                  </div>)
                  : null
              }
            </div>
          </div>
        </div>
        <div className="flex justify-end my-2">
          <div className="flex px-4 ">
            <button onClick={() => setPage(prev => prev - 1)} disabled={page == 1}><FaChevronLeft size={25} color={page == 1 ? 'gray' : 'black'} /></button>
            <button onClick={() => setPage(prev => prev + 1)} disabled={page * 10 >= Math.max(trendsData.socialTrends.length, trendsData.retailerTrends.length)}><FaChevronRight size={25} color={page * 10 >= trendsData.retailerTrends.length ? 'gray' : 'black'} /></button>
          </div>
        </div>
      </>}

    <Popup isPopUp={selectedTagValue != null} setIsPopUp={() => { setSelectedTagValue(null); }}>
      {
        selectedTagValue
          ? <TrendImages searchParams={searchParams} trendType={selectedTagValue.trendType} tag={selectedTagValue.tag} value={selectedTagValue.value} />
          : null
      }
    </Popup>

  </div >
}

export default GroupTrend
